import React from 'react';
// import FaceDetectionProvider from './useFaceDetection';
import FaceDetection from './FaceDetection';
import FaceMatcherProvider from './useFaceDetection';

const FRfaceDetection = params => {
  return (
    <FaceMatcherProvider params={params}>
      <FaceDetection />
    </FaceMatcherProvider>
  );
};

export default FRfaceDetection;
